<div class="shipment-order-specs-container">
  <div class="orders-header" *ngIf="showHeader || showSearch">
    <div class="header-left" *ngIf="showHeader">
      <div class="empty-title">
        <img class="title-icon" src="assets/icons/job-planning/gift.svg" alt="" aria-hidden="true" />
        <span class="orders-label">Orders</span>
        <span class="order-count-badge">{{ filteredOrders?.length || 0 }}</span>
      </div>
    </div>

    <div class="search-bar" *ngIf="showSearch">
      <input
        type="text"
        class="search-input"
        placeholder="SEARCH BY ORDER REF ID"
        [(ngModel)]="searchText"
        (input)="onSearchChange()"
      />
    </div>
  </div>

  <div class="orders-table">
    <!-- Table Header -->
    <div class="table-header">
      <div class="header-cell checkbox-cell" *ngIf="selectable"></div>
      <div class="header-cell order-id-cell">Order Id</div>
      <div class="header-cell consignee-cell">Consignee</div>
      <div class="header-cell volume-cell">Total Volume</div>
      <div class="header-cell weight-cell">Total Weight</div>
      <div class="header-cell actions-cell"></div>
    </div>

    <!-- Table Rows -->
    <ng-container *ngFor="let order of filteredOrders; let i = index">
      <div class="row-with-icon">
        <img *ngIf="showRemoveIcon"
             class="minus-icon" 
             src="assets/booking-engine/icons/minus-icon.png" 
             alt="Remove from container" 
             aria-label="Remove order from container"
             style="cursor: pointer;"
             (click)="onRemoveFromContainer(order)"/>
        <hmt-order-row
          [order]="order"
          [selectable]="selectable"
          [deletable]="deletable"
          [isExpanded]="isExpanded(order.orderId)"
          (toggleExpand)="toggleExpand(order.orderId)"
          (deleteOrder)="onDeleteOrder(order, $event)"
          (selectOrder)="onSelectOrder(order, $event)">
        </hmt-order-row>
      </div>


      <!-- Separator Line -->
      <div class="row-separator" *ngIf="i < filteredOrders.length - 1"></div>
    </ng-container>

    <!-- Empty State -->
    <div class="empty-state" *ngIf="filteredOrders.length === 0 && showSearch && searchText">
      <mat-icon class="empty-icon">search_off</mat-icon>
      <div class="empty-text">No orders found</div>
      <div class="empty-subtext">Try adjusting your search criteria</div>
    </div>
  </div>
</div>

